//  真实姓名可输入的长度
export const REAL_NAME_LEN = 128
